module.exports = __webpack_public_path__ + "img/side exposed 10mm zipper length.ef5d5bb1.png";